import React from 'react'

import Loading from '../../components/Loading'
import Window from '../../components/Divs/Window'

const Component = (props) => {
  return (
		<Window>
			<Loading />
		</Window>
  )
}
export default Component
